var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.035 30H7V12h21l1 2h5c1.667 2.657 5 7 5 7v9h-3.115c-.164 1.653-1.34 3-3.369 3-2.028 0-3.279-1.424-3.367-3H16.965a3.5 3.5 0 0 1-6.93 0Zm6.63-1.995a3.5 3.5 0 0 0-6.33-.002M37 25v3h-1.142c-.718-1.305-1.813-1.963-3.285-1.975-1.561-.012-2.702.646-3.424 1.975H29V16h4l4 6v3Zm-.651-4 .652 1H31v-4h3.325l1.71 2.556.314.444ZM9 14h18v14H9V14Zm23.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-19 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm22.535-7.444L34.935 19H32v2h4.332l-.297-.444Z",
  id: "delivery_svg__a"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "#2D2D2D",
  xlinkHref: "#delivery_svg__a",
  fillRule: "evenodd"
})));
export default SvgDelivery;